export type NotificationModel = {
  id: number,
  audience: 'agencies' | 'brands' | 'global' | 'providers',
  body: string,
  cache_key: number,
  creator_id?: number,
  creator_type?: string,
  dates: {
    created: {
      date_time: string,
    },
  },
  end_date?: string,
  link?: string,
  notifiable_id?: number,
  notifiable_type?: 'Agency' | 'Brand' | 'Provider',
  options: {
    location?: string,
    primary_link_title?: string,
    primary_link_url?: string,
    realhub_platform?: 'legacy' | 'standalone_v1',
    secondary_link_title?: string,
    secondary_link_url?: string,
    video_id?: string,
    video_provider: string,
  },
  read: boolean,
  subject_id?: number,
  subject_type?: 'Artwork' | 'Campaign' | 'CampaignPortalSync' | 'CustomDeadline' | 'Image',
  start_date?: string,
  title: string,
}

export type NotificationRequestOptions = {
  include_attachment_file?: boolean,
  include_notification_creator_logo?: boolean,
  include_notification_image?: boolean,
  include_notification_notifiable?: boolean,
  include_notification_subject?: boolean,
  limit?: number,
}

const state = {
  id: null,
  audience: '',
  body: '',
  end_date: '',
  link: '',
  notifiable_id: undefined,
  notifiable_type: '',
  options: {
    dismissable: true,
  },
  start_date: '',
  title: '',
}

export const requiredFields = [
  { key: 'audience' },
  { key: 'body' },
  {
    key: 'end_date',
    validation: (value: string, entityState: NotificationModel) => (entityState.start_date ? !!value : true),
  },
  {
    key: 'options.primary_link_title',
    validation: (value: string, entityState: NotificationModel) => (
      entityState.options?.primary_link_url ? !!value : true
    ),
  },
  {
    key: 'options.primary_link_url',
    validation: (value: string, entityState: NotificationModel) => (
      entityState.options?.primary_link_title ? !!value : true
    ),
  },
  {
    key: 'options.secondary_link_title',
    validation: (value: string, entityState: NotificationModel) => (
      entityState.options?.secondary_link_url ? !!value : true
    ),
  },
  {
    key: 'options.secondary_link_url',
    validation: (value: string, entityState: NotificationModel) => (
      entityState.options?.secondary_link_title ? !!value : true
    ),
  },
  {
    key: 'start_date',
    validation: (value: string, entityState: NotificationModel) => (entityState.end_date ? !!value : true),
  },
  { key: 'title' },
]

export default state
